<div class="container missing-data-offer" [ngClass]="{ 'missing-data-offer--between-offers': displayedBetweenOffers,
                                                       'missing-data-offer--faded': faded }">
    <div class="missing-data-offer__top-info-wrapper">
        <div class="missing-data-offer__top-info">{{ topInfo | translate }}</div>
    </div>
    <div class="missing-data-offer__content">
        <div class="missing-data-offer__details">
            <div class="missing-data-offer__details__logos">
                <div class="missing-data-offer__details__logo" *ngFor="let logo of logos">
                    <img [src]="logo">
                </div>
            </div>
            <div class="missing-data-offer__details__info">
                {{ missingParamsInfo | translate }}
            </div>
        </div>
        <div class="missing-data-offer__buttons">
            <button class="btn btn--blue missing-data-offer__buttons__back-to-data" (click)="backToData()"> {{ 'MISSING_DATA_OFFER_COMPONENT.backToDataButton' | translate }} <span>&gt;</span></button>
            <button class="btn btn--clear" (click)="orderCall()"> {{ 'OFFER_SECTION.SHARED.orderCall' | translate }} </button>
        </div>
    </div>
</div>
